import { CandidateVerificationsTab } from '../../components/CandidateVerificationsTab';

export function SuperadminVerifications() {
  return <CandidateVerificationsTab />;
}
